export const navSlice = (set) => ({
	lastPageData: null,
	setLastPageData: (data) => set({ lastPageData: data }),
	removeLastPageData: () => set({ lastPageData: null }),
	searchedUsers: null,
	setSearchedUsers: (users) => set({ searchedUsers: users }),
});
